import React, { useState } from "react"
import { LabelledProgressBar } from "@modules/ui/components/LabelledProgressBar"
import { Em } from "@modules/ui/components/Em"
import { BillingPlanLimits } from "@modules/enums/constants"
import { useTracker, GAEventType } from "@modules/analytics"
import { Tooltip } from "gatsby-interface"
import { MdInfoOutline } from "react-icons/md"
import { organizations as text } from "@modules/locales/default.js"

const textCss = theme => ({
  fontSize: theme.fontSizes[0],
  color: theme.colors.grey[50],
})

const trialRowCss = _theme => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flex: 1,
})

const buttonNoStyleCss = theme => ({
  border: "none",
  background: "transparent",
  padding: 0,
  display: "flex",
  alignItems: "center",
  marginLeft: theme.space[1],
})

const forceOneLineCss = _theme => ({
  minWidth: `max-content`,
})

function TrialToolTip() {
  const { trackGoogleAnalytics } = useTracker()
  const [trackedInputEvent, setTrackedInputEvent] = useState(false)

  const trackViewingEndOfTrialInfo = () => {
    if (!trackedInputEvent) {
      trackGoogleAnalytics({
        eventType: GAEventType.View,
        category: `Product Engagement - Dashboard`,
        label: { text: `end of trial information`, loc: `subnav` },
      })
      setTrackedInputEvent(true)
    }
  }

  return (
    <Tooltip label={text.messages.afterYourTrialEnds}>
      <button
        aria-label="Note about trial"
        onFocus={trackViewingEndOfTrialInfo}
        onMouseEnter={trackViewingEndOfTrialInfo}
        css={theme => [textCss(theme), buttonNoStyleCss(theme)]}
      >
        <MdInfoOutline />
      </button>
    </Tooltip>
  )
}

export function TrialRemainingDays({ days, noTooltip = false, ...rest }) {
  if (days < 0 || days === null || typeof days === `undefined`) {
    return null
  }

  if (days === 0) {
    return (
      <div css={trialRowCss} {...rest}>
        <span css={textCss}>Your trial ends today</span>
        <TrialToolTip />
      </div>
    )
  }

  return (
    <div css={trialRowCss} {...rest}>
      <LabelledProgressBar
        value={days}
        max={BillingPlanLimits.trialingDays}
        id="remaining-days"
      >
        {days === 1 ? (
          <span data-testid="one-day-remaining" css={forceOneLineCss}>
            <Em>1</Em> day remaining in your free trial
          </span>
        ) : (
          <span data-testid="multiple-days-remaining" css={forceOneLineCss}>
            <Em>{days}</Em> days remaining in your free trial
          </span>
        )}
        {!noTooltip && <TrialToolTip />}
      </LabelledProgressBar>
    </div>
  )
}
